import { useEffect, useState } from "react";
import Spinner from "./Spinner/spinner";
import callApi from "../../../utility/apiCaller";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setKfsUrl } from "../../../store/app/aaSlice";
import { useLocation } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import Header from "./Header/header";

export const CallbackHandlerScreen = ({ setCurrentStep }) => {
  // 🔹 Retry util with exponential backoff

  const [nachFailed, setNachFailed] = useState(false);
  const user = useSelector((state) => state.app.user);
  const aaSlice = useSelector((state) => state?.aa);
  const dispatch = useDispatch();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search.split("?").join("&"));
  console.log(queryParams);
  const data = queryParams.get("data");
  console.log("date from url: ", data);
  console.log(aaSlice);
  const appId = aaSlice?.appId;
  const client_leadId = aaSlice?.leadId;
  const responseId = aaSlice?.responseId;
  const opportunityId = aaSlice?.OpportunityId;
  const lead_Id = aaSlice?.internalLeadId;
  const eMendateUrl = aaSlice?.eMendateUrl;
  console.log("opportunityId", opportunityId);
  const withRetry = async (fn, retries = 3, delay = 1000) => {
    let attempt = 0;
    while (attempt < retries) {
      try {
        return await fn();
      } catch (err) {
        attempt++;
        if (attempt >= retries) throw err;
        console.warn(`Retrying... attempt ${attempt}`);
        await new Promise((res) => setTimeout(res, delay * attempt)); // backoff
      }
    }
  };

  useEffect(() => {
    if (data === "exit") {
      setNachFailed(true);
    }
  }, [data]);

  // 🔹 Wrapper for API + validation
  const callApiWithRetryAndTest = async (
    apiFunc,
    retries,
    delay,
    testFunc,
    errorMsg
  ) => {
    return await withRetry(
      async () => {
        const res = await apiFunc();
        if (testFunc && !testFunc(res)) {
          throw new Error(errorMsg || "Validation failed");
        }
        return res;
      },
      retries,
      delay
    );
  };

  useEffect(() => {
    // check if we already refreshed once
    const alreadyRefreshed = sessionStorage.getItem("CallBackRefreshed");

    if (!alreadyRefreshed) {
      sessionStorage.setItem("CallBackRefreshed", "true");
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    if (data === "exit") return;
    const runCallbacks = async () => {
      try {
        const nachRes = await callApiWithRetryAndTest(
          () =>
            callApi(
              `v1/callback/list`,
              "post",
              {
                filters: {
                  event: "NACH_Master_Callback",
                  applicationid: appId,
                },
              },
              "loan-service"
            ),
          5,
          2000,
          (res) => {
            const list = res?.data?.callbackList || [];
            if (!list.length) return false;
            const latest = list[0];
            return (
              latest?.nachcompleted === "Yes" && latest?.decision === "Approved"
            );
          },
          "❌ NACH Master callback failed"
        );
        console.log(
          "✅ NACH Callback success:",
          nachRes?.data?.callbackList[0]
        );

        // 4️⃣ CPV_Callback
        // const cpvRes = await callApiWithRetryAndTest(
        //   () =>
        //     callApi(
        //       `v1/callback/list`,
        //       "post",
        //       {
        //         filters: {
        //           event: "CPV_Callback",
        //           key: opportunityId,
        //         },
        //       },
        //       "loan-service"
        //     ),
        //   5,
        //   2000,
        //   (res) => {
        //     const list = res?.data?.callbackList || [];
        //     if (!list.length) return false;
        //     const latest = list[0];
        //     return latest?.Status === "Approved";
        //   },
        //   "❌ CPV callback failed"
        // );
        //console.log("✅ CPV Callback success:", cpvRes?.data?.callbackList[0]);
        const KfsServiceRes = await callApiWithRetryAndTest(
          () =>
            callApi(
              `v1/lender/kfs_service`,
              "post",
              {
                lenderResponseID: responseId,
                dmi_opportunityid: opportunityId,
                application_id: appId,
                dmi_lead_id: client_leadId,
              },
              "loan"
            ),
          5,
          2000,
          (res) => res?.data?.statuscode === 200 && !!res?.data?.body?.kfsurl, // ✅ check status & URL
          "❌ KFS Signing callback failed"
        );

        if (KfsServiceRes?.data?.body?.kfsurl) {
          dispatch(setKfsUrl(KfsServiceRes?.data?.body?.kfsurl));
        }

        await callApiWithRetryAndTest(
          () =>
            callApi(
              `v1/lead/${lead_Id}/update-lead-new`,
              "post",
              {
                lead: {
                  is_kfs_completed: true,
                  steps_completed: 13,
                  kfsurl: KfsServiceRes?.data?.body?.kfsurl,
                },
              },
              "core",
              user?.token ||
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
            ),
          3,
          1000,
          (res) => res?.status === "Success", // test function for lead
          "❌ Update lead failed"
        );

        const redirectUrl = KfsServiceRes?.data?.body?.kfsurl;

        if (redirectUrl) {
          // 🔹 Redirect user to KFS signing page
          // window.location.href = redirectUrl;
        } else {
          console.warn("No KFS URL found in response");
        }

        // ✅ All callbacks done → move to next step
        setCurrentStep((prev) => prev + 1);
      } catch (err) {
        console.error("❌ Callback handler failed:", err);
        //setCurrentStep((prev) => prev + 1);
        // TODO: show retry button or error message to user
      }
    };

    runCallbacks();
  }, [appId, responseId, opportunityId, client_leadId, nachFailed]);

  return (
    <div className="flex flex-col font-atkinson w-full max-w-[400px] items-center h-[100dvh] justify-center bg-white text-center px-4">
      {nachFailed ? (
        <div className="h-screen w-full ">
          <div className="w-full">
            <Header />
          </div>
          <div className="absolute inset-0 flex flex-col items-center justify-center  z-10 p-6">
            <AlertCircle className="w-16 h-16 text-red-600 mb-4 animate-pulse" />
            <h2 className="text-2xl font-semibold text-red-700 mb-2">
              E-Mendate Verification Failed
            </h2>
            <button
              onClick={() => {
                if (eMendateUrl) {
                  window.location.href = eMendateUrl; // Redirect to KYC URL
                }
              }}
              className="bg-green-700 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              Retry E-mendate
            </button>
          </div>
        </div>
      ) : (
        <>
          <Spinner />
          <h2 className="mt-4 text-lg font-bold text-gray-900">Hang tight!</h2>
          <p className="mt-1 text-[15px] text-gray-600">
            Processing your details, this may take a few seconds…
          </p>

          <div className="absolute bottom-6 flex flex-col items-center">
            <div className="text-center text-xs text-gray-500">
              <img
                src="/assets/img/Footer logo.png"
                alt="Digitmoney logo"
                className="mx-auto h-4 mb-1"
              />
              Lending Partner{" "}
              <img
                src="/assets/img/dmiicon.png"
                alt="DMI Finance logo"
                className="inline h-4 ml-1"
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
